var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowForwardIosDark20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_733_2609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_733_2609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios_2",
    d: "M6.11539 17.4259C5.9359 17.2464 5.84616 17.0389 5.84616 16.8033C5.84616 16.5678 5.9359 16.3602 6.11539 16.1808L12.2965 9.99965L6.09455 3.79772C5.92361 3.62679 5.83813 3.42754 5.83813 3.19997C5.83813 2.97241 5.93055 2.76622 6.11539 2.5814C6.28098 2.41581 6.48504 2.33301 6.72755 2.33301C6.97007 2.33301 7.17412 2.41581 7.33972 2.5814L14.1971 9.43076C14.289 9.52263 14.3544 9.61531 14.3934 9.7088C14.4324 9.80227 14.4519 9.89922 14.4519 9.99965C14.4519 10.1001 14.4324 10.197 14.3934 10.2905C14.3544 10.384 14.289 10.4767 14.1971 10.5686L7.31889 17.4468C7.13407 17.6316 6.93001 17.7171 6.70672 17.7032C6.48343 17.6893 6.28632 17.5969 6.11539 17.4259Z",
    fill: "#111827"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIosDark20);
export default __webpack_public_path__ + "static/media/arrow_forward_ios_dark_20.eedec600cc72d42ec1a820a6a1f027b7.svg";
export { ForwardRef as ReactComponent };